export default __webpack_public_path__ + "static/media/imgnotfound.2b47087f.png";